import { css } from "styled-components/macro";
import { rgba } from "polished";
import { fontStyle, transition, colors } from "shared/styles/constants";
import { hoverFocus } from "shared/styles/defaults";

export const defaultLink = (
  color: colors = colors.grey5,
  borderColor: colors = colors.grey4
) => css`
  display: inline;

  color: ${color};
  ${fontStyle.medium}
  text-decoration: none;

  transition: box-shadow ${transition.default};

  border-bottom: 2px solid ${rgba(borderColor, 0.25)};

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  &:hover {
    &:not(:disabled) {
      border-bottom: 2px solid ${borderColor};
    }
  }

  ${hoverFocus.defaultFocus};
`;
